import {
  put,
  fork,
  takeLatest
} from 'redux-saga/effects';
import {NORMALIZE_DATA} from '../../dataProvider/dataProvider';
import {SET_DATA} from './customer';
import {setConsumerType, SET_SALES_SESSION_ID} from '../../common/common';

// WATCHERS
export function* normalizeWatch() {
  yield takeLatest(NORMALIZE_DATA, normalizeWorker);
}

// WORKERS
export function* normalizeWorker({key, data, meta}) {
  if (key !== 'customer') {
    return;
  }

  yield put({
    type: SET_DATA,
    payload: {
      ...meta,
      customer: data.customerInfo
    }
	});

  yield put({
    type: SET_SALES_SESSION_ID,
    salesSessionId: data.customerInfo.salesSessionId
	});
	yield put(setConsumerType(data.consumerType));
}

export default function* customerSagas() {
  yield [
    fork(normalizeWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/customer/customerSagas.js
 **/